module.exports = __webpack_public_path__ + "img/message-schedule@2x.f268f3fd.png";